import { Placeholder as RawPlaceholder } from '@wearetla/tla-essentials-tools/partials/placeholder';
import classNames from 'classnames';
import '/assets/styles/partials/placeholder.scss';

const Placeholder = ({ light, className, ...props }) => (
	<RawPlaceholder {...props} className={classNames(className, { light })} />
);

export default Placeholder;
